import React from "react";
import Navbar from "./navbar";
import DividerTop from "./divider-top";
import ScoutLogo from "../assets/images/Scouts-Logo-Stack-Purple.png";

function Header() {
  return (
    <header>

      <Navbar />

      <section id="page-title">
        <div className="header-title-container">
          <h1>17th Bournemouth Scout Group</h1>
          <p>Join us for fun, adventure, and learning new skills.</p>
        </div>

        <div className="header-icon-container">
          <img src={ScoutLogo} alt="Scouts Logo" id="logo"/>
        </div>
      </section>

      <div className="divider-container">
        <div className="divider">
          <p>"Leave this world a little better than you found it." ~ Robert Baden-Powell</p>
        </div>
      </div>

      <DividerTop />

    </header>
  );
}

export default Header;